import createModel from './lib/create_model';

export default createModel({
  modelName: 'SystemConfiguration',
  properties: {
    fbAppId: String,
    publicUrl: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
